module.exports = __webpack_public_path__ + "img/about-cover-1.4b039d66.png";